import { render, staticRenderFns } from "./KitsBusqueda.vue?vue&type=template&id=1dd972c2&"
import script from "./KitsBusqueda.vue?vue&type=script&lang=js&"
export * from "./KitsBusqueda.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports